import {
  Box, Button, CircularProgress, CssBaseline, FormControl, Grid, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextareaAutosize, TextField, Tooltip, Typography, ClickAwayListener
} from '@material-ui/core';
import { withStyles, styled } from '@material-ui/core/styles';
import SearchIcon from "@material-ui/icons/Search";
import DeleteIcon from '@material-ui/icons/Delete';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getSupportRequestLists, getSupportCategories, submitSupportTicket, uploadSupportDocuments, deleteSupportDocuments, downloadSupportDocument, insertActivityLog } from '../../actions';
import { getAppSource, getUserType, isAdminCheck, maskLoan, renderDefaultMsg } from '../../helpers';
import CustomBreadcrum from '../Breadcrum';
import {FilterDrawer} from './FilterDrawer';
import { Requests } from './Requests';
import { useStyles } from './styles';

import Filter from '../../assets/filter.svg';
import CancelIcon from '@material-ui/icons/Cancel';
import imageIcon from '../../assets/image.png';
import pdfIcon from '../../assets/SupportTicket/pdfIcon.svg';
import InfoIcon from '@material-ui/icons/Info';

import databaseIcon from '../../assets/RequestDocument/Database.png';
import { decrypt } from '../../helpers/encrypt';
import { DeleteConfirmation } from '../ManageBankAccount/DeleteConfirmationOnAccount/DeleteConfirmation';
import { RequestSubmitPopup } from './RequestSubmitPopup';
import { FileSizeAlert } from '../PayoffRequest/FileSizeAlert';
import { DocumentRequestPopup } from './DocumentRequestPopup';
import { FILE_LENGTH, FILE_LENGTH_LIMIT } from '../../helpers/constants';
import { scrollTop } from '../../helpers';
import { useLocation } from 'react-router-dom';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { FileExtensionAlert } from '../IdentityThefts/FileExtensionAlert';
import ClearIcon from '@material-ui/icons/Clear';
import Cookies from 'js-cookie';
import moment from 'moment';
import './styles.css';

const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

const LightTooltip = withStyles((theme) => ({
  arrow: {
    color: '#235A86'
  },
  tooltip: {
    backgroundColor: '#235A86',
    color: '#fffff',
    fontFamily: "Montserrat",
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    padding: "16px",
    fontSize: 14,
    maxWidth: 400,
    fontWeight: 500,
    borderRadius: 8
  },
}))(Tooltip);

export const SupportTicket = (props) => {

  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const theme = useTheme();
  const mediaQuery = useMediaQuery(theme.breakpoints.down('sm'))
  
  const accounts = useSelector(state => state.accounts);
  const supportInfo = useSelector(state => state?.loanInfoReducer);
  
  const [accountsToFilter, setAccounts] = useState([]);
  const [allSelected, setAllSelected] = useState(true);
  const [loader, setLoader] = useState(false);
  const [openFilter, setOpenFilter] = useState();
  const [filterValuesApply, setFilterValuesApply] = useState({ status: { 'In Progress': false, 'Completed': false, 'Clarification Needed': false, 'Submitted': false, 'Reopen': false }, customEnd: null, customStart: null, requestedDates: { startDate: '', endDate: '', requestedPeriod: '' } , categories: []  });
  const [noResultFoundOnSearch, setResultFoundOnSearch] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [openForm, setFormStatus] = useState(false);
  const [requestLists, setRequestLists] = useState([]);
  const [requestListsFromApi, setRequestListsFromApi] = useState([]);
  const [documentType, setDocumentType] = useState();
  const [documentRequestId, setDocumentId] = useState();
  const [documentDesc, setDocumentDesc] = useState("");
  const [errMessage, setErrorMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [filterApplied, setFilterApplied] = useState();
  const [popupText, setPopupText] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  const [noResultFound, setNoResultFound] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [requestDocLists, setRequestDocLists] = useState();
  const [selectedLoan, setSelectedLoan] = useState({ accountNumber: "" });
  const [addDescriptionStatus, setDescriptionStatus] = useState(false);
 
  const [file, setFilesName] = useState('');
  const [fileLengthStatus, setFileLengthStatus] = useState(false);
  const [replaceStatus, setReplaceStatus] = useState(false);
  const [documentId, setDocumentIds] = useState(0);
  const [alertStatus, setAlertStatus] = useState(false);
  const [specialChar, setFileContainSpecialChar] = useState(false);
  const [docs, setDocs] = useState([]);
  const [replaceIndex, setReplaceIndex] = useState();
  const [deleteStatus, setDeletePopup] = useState(false);
  const [counter, setCounter] = useState(1);
  const [requestPopup, setRequestPopup] = useState(false);
  const [submitResponse, setSubmitResponse] = useState();
  const [documentRequestPopup, setDocumentRequestPopupStatus] = useState(false);
  const [paginationData, setPaginationData] = useState();
  const [createTicket, setCreateTicket] = useState(false);
  const [openToolTip, setOpenToolTip] = useState(false);
  const [allowedExtensionsStatus, setAllowedExtensionsStatus] = useState(false);
  const [fileUploadLoader, setFileUploadLoader] = useState(false);
  const [btnDisabled, setSupportRequestStatus] = useState();
   
  useEffect(() => {
    if (supportInfo.length == 0) {
      setSupportRequestStatus(false)
    } else {
      setSupportRequestStatus(supportInfo?.isSupportTicketAllowed)
      if (supportInfo && !supportInfo.isSupportTicket) {
        history.push('/Dashboard?access=false');
      }
    }
  }, [supportInfo])

  const handleExtensionAlertClose = () => setAllowedExtensionsStatus(false)

   const handleTooltipClose = () => {
     setOpenToolTip(false);
   };
 
   const handleTooltipOpen = () => {
     setOpenToolTip(true);
   };

  const handleSearch = (event) => {
    setSearchInput(event.target.value)
  }
  const keyPress = (e) => {
    if (e.keyCode == 13) {
      e.preventDefault()
      handleSearchClick();
    }
  }

  useEffect(() => {
    Cookies.remove('redirectUrl')
    Cookies.remove('SupportRequestNumber')
    if (props.accountNumber) {
      applyMultiLoanFilter('all');
      setResultFoundOnSearch(false);
      setNoResultFound(false);
      getCategories(props)
      getDocumentListFunc(1, null)
    }
  }, [props.accountNumber])

  useEffect(() => {
    if (((location.search.split('?SupportRequestNumber=')[1] !== undefined) && (requestListsFromApi?.length > 0))) {
      const input = location.search.split('?SupportRequestNumber=')[1]
      const queryParams = new URLSearchParams(location.search)
      setSearchInput(input)
      searchClick(queryParams.get('SupportRequestNumber'))
      if (queryParams.has('SupportRequestNumber')) {
        queryParams.delete('SupportRequestNumber')
        history.replace({
          search: queryParams.toString(),
        })
      }
    }
  }, [((location.search.split('?SupportRequestNumber=')[1] !== undefined) && (requestListsFromApi?.length > 0))])

  
  const sendActivityData = async (message, action) => {
    const remark = message;
    const data = {
      "accountNumber":  accounts.length == 1 ? props?.accountNumber : selectedLoan.accountNumber,
      "activityCode": "UAL205",
      "activityStatus": "Success",
      "action": action,
      "controller": "SupportTicket",
      "apiName": "SupportTicket",
      "activityRemark":  remark,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": "",
    };

    await insertActivityLog(data);
  }
  
  const searchClick = (searchInput) => {
    const updatedDocLists = requestListsFromApi.filter((item) => {
      return item.supportRequestNumber.toLowerCase().includes(searchInput?.toLowerCase())
    })

    setRequestLists(updatedDocLists);
    if (updatedDocLists == 0) {
      setResultFoundOnSearch(true)
    }
  }

  useEffect(() => {
    setAccounts(accounts)
    if (accounts.length == 1) {
      setSelectedLoan({accountNumber: accounts[0].accountNumber})
    }
  }, [props.accountNumber, accounts])

  const getCategories = async (props) => {
    const data = {
      "accountNumber": props?.accountNumber,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getSupportCategories(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      setDocumentTypes([])
      setSelectedItem({})
      setDocumentId()
      setDocumentDesc("")
      setDocumentTypes(res?.responseData?.responseData)
    } else {
      scrollTop()
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const getDocumentListFunc = async (pageNumber, acccountNumber) => {
    setLoader(true)
    const data = {
      "accountNumber": acccountNumber, 
      "pageNumber" : pageNumber,
      "pageSize": 10,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await getSupportRequestLists(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      setSearchInput("");
      setFilterValuesApply({ status: { 'In Progress': false, 'Completed': false, 'Clarification Needed': false, 'Submitted': false, 'Reopen': false }, customEnd: null, customStart: null, requestedDates: { startDate: '', endDate: '', requestedPeriod: '' }, categories: [] })
      setFilterApplied(false);
      closeDrawer();
      
      if (res?.responseData?.responseData?.supportRequestModelList.length == 0) {
        setNoResultFound(true)
      } else {
        setNoResultFound(false)
      }
      setLoader(false)
      setRequestLists(res?.responseData?.responseData?.supportRequestModelList);
      setRequestListsFromApi(res?.responseData?.responseData?.supportRequestModelList);
      setRequestDocLists(res?.responseData?.responseData?.supportRequestModelList)
      setPaginationData(res?.responseData?.responseData);
      if (pageNumber == 1) {
        const submittedTicketLists = res?.responseData?.responseData?.supportRequestModelList.filter((ticket) => ticket.status.toLowerCase() !== 'completed');
        if (submittedTicketLists.length > 4) {
          setCreateTicket(true)
        }
      }
    } else {
      setLoader(false)
      setRequestLists([]);
      setRequestListsFromApi([]);
      setRequestDocLists([]);
      setErrorMessage(renderDefaultMsg('400'))
    }
  }

  const submitRequestDocument = async () => {
    setLoader(true)
    const data = {
      "categoryCode": selectedItem.categoryCode,
      "categoryType": selectedItem.categoryName,
      "description": documentDesc,
      "documentId":  docs.map((key) => key.documentId),
      "accountNumber": accounts.length == 1 ? props?.accountNumber : selectedLoan.accountNumber,
      "sla": selectedItem.sla,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get('publicIp'),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName": ""
    };

    const res = await submitSupportTicket(data);
    if (res?.responseData?.lstResponseStatus[0]?.statusCode == 0) {
      clearFormData()
      setSearchInput('')
      setSubmitResponse(res.responseData.responseData)
      setRequestPopup(true)
      getDocumentListFunc(1, null);
      setFilterApplied(false);
      setSearchInput('');
      setFilterValuesApply({ status: { 'In Progress': false, 'Completed': false, 'Clarification Needed': false, 'Submitted': false, 'Reopen': false }, customEnd: null, customStart: null, requestedDates: { startDate: '', endDate: '', requestedPeriod: '' } , categories : [] })
      applyMultiLoanFilter('all');
      setLoader(false)
      setResultFoundOnSearch(false);
      setNoResultFound(false);
    } else {
      scrollTop()
      setLoader(false)
      setErrorMessage(res?.responseData?.lstResponseStatus[0]?.statusDesc)
    }
  }

  const clearFormData = () => {
    setErrorMessage("")
    setSelectedItem({})
    setDocumentDesc("");
    setDocumentType()
    setDocumentId()
    setFormStatus(false)
    setDescriptionStatus(false)
    setDocs([])
  }

  const handleRequestDescChange = (event) => {
    setDocumentDesc(event.target.value.replace(/^\s+/, ''))
  }

  if (loader) {
    return (
      <Box className={classes.loader}>
        <CircularProgress />
      </Box>
    )
  }

  const selectedLoanDetails = (loan) => {
    setSelectedLoan(loan)
  }

  let allDocumentTypes = '';
  if (documentTypes && documentTypes?.length) {
    allDocumentTypes = documentTypes.map((item) => {
      return (
        <MenuItem value={item.categoryCode} key={item.categoryCode} onClick={() => selectDocumentType(item)}>{item.categoryName}</MenuItem>
      )
    })
  }

  let loansDetails = '';
  if (accounts && accounts?.length) {
    loansDetails = accounts.map((loan) => {
      return (
        <MenuItem value={loan.accountNumber} key={loan.accountNumber} onClick={() => selectedLoanDetails(loan)}><span className={classes.loan}>{decrypt(loan.accountNumber)} - </span> {loan.propertyAddress1}</MenuItem>
      )
    })
 
  }

  const calculateCommentLenth = () => {
    const length = documentDesc?.length
    if (isNaN(length)) {
      return 0
    } else {
      return length
    }
  }

  const selectDocumentType = (item) => {
    setDocumentDesc("");
    setDocumentType(item?.documentName);
    setDocumentId(item?.documentCode);
    setSelectedItem(item);
    if (item.categoryCode == 'DR') {
      setDocumentRequestPopupStatus(true)
    }
  }

  const openFilters = () => {
    if (noResultFound) {
      setOpenFilter(false);
    } else {
      setOpenFilter(true);
    }
  }

  const closeDrawer = () => {
    setOpenFilter(false);
  }

  const openNewReqForm = () => {
    setFormStatus(true)
    sendActivityData("Support Ticket - Clicked on Create Ticket button", "SupportSubmit")
  }

  const closeForm = (msg, action) => {
    sendActivityData(msg, action)
    clearFormData()
    setFormStatus(!openForm)
  }

  const checkValidations = () => {
    if (isAdminCheck() || !selectedLoan.accountNumber || !selectedItem.categoryCode || !documentDesc || (selectedItem.categoryCode == 'DR')) {
      return true
    } else {
      return false
    }
  }

  //When select radio button in filter
  //when left side drawer filters are applied
  const applyFilter = (value, filterValues) => {
    
    setSearchInput('');
    if (accountsToFilter?.length == 1) {
      applyMultiLoanFilter('all', true);
    }
    setFilterValuesApply(filterValues);

    const keys = Object.keys(filterValues?.status) || [];
    const data = keys.filter((data) => {
      return filterValues.status[data] === true;
    }) || [];
    const isStatusApplied = data.length ? true : false;
    const isDateApplied = filterValues.requestedDates.requestedPeriod ? true : false;
    const isCategoryApplied = Array.isArray(filterValues.categories) && filterValues.categories.length > 0;

    const startDate = moment(filterValues.requestedDates.startDate).format('MM/DD/YYYY');
    const endDate = moment(filterValues.requestedDates.endDate).format('MM/DD/YYYY');
    const selectedCategoryNames = isCategoryApplied
    ? filterValues.categories.map(cat => cat.categoryName)
    : [];

    setResultFoundOnSearch(false);
   
    const filteredData = requestListsFromApi.filter(request => {
      const updatedDate = moment(request.updatedDate).format('MM/DD/YYYY');
      const statusMatch = isStatusApplied ? filterValues.status[request.status] : true;
      const dateMatch = isDateApplied
        ? updatedDate >= startDate && updatedDate <= endDate
        : true;
      const categoryMatch = isCategoryApplied
        ? selectedCategoryNames.includes(request.categoryType)
        : true;
     
      return statusMatch && dateMatch && categoryMatch;
    });

    if (!filteredData.length) {
      setResultFoundOnSearch(true);
    }
    else {
      setResultFoundOnSearch(false);
    }
    if (!isDateApplied && !isStatusApplied && !isCategoryApplied) {
      setRequestLists(requestListsFromApi);
      setResultFoundOnSearch(false);
    }
    else {
      setRequestLists(filteredData);
    }

    if (!value) {
      if (isDateApplied || isStatusApplied || isCategoryApplied)
        setFilterApplied(true);
      closeDrawer();
    }
  }

  const applyAllFilter = () => {
    setFilterValuesApply({ status: { 'In Progress': false, 'Completed': false, 'Clarification Needed': false, 'Submitted': false, 'Reopen': false }, customEnd: null, customStart: null, requestedDates: { startDate: '', endDate: '', requestedPeriod: '' } , categories: [] })
    setSearchInput('');
    setFilterApplied(false);
    let acc = accounts.map((data) => {
      data.selected = false;
      return data;
    });

    setAccounts(acc);
    setAllSelected(true);
    getDocumentListFunc(1, null)
  }

  const applyMultiLoanFilter = (value, isFromSearch) => {
    setResultFoundOnSearch(false)
    setFilterValuesApply({ status: { 'In Progress': false, 'Completed': false, 'Clarification Needed': false, 'Submitted': false, 'Reopen': false }, customEnd: null, customStart: null, requestedDates: { startDate: '', endDate: '', requestedPeriod: '' } , categories: [] })
    if (!isFromSearch)
    setSearchInput('');
    setFilterApplied(false);

    const filteredData = requestListsFromApi.filter(filterValue => {
      // Filter by accountNumber
      if (value && value === filterValue.accountNumber && value !== 'all') {
        return true;
      }
      return false;
    });

    if (value && value !== 'all') {
      // if (!filteredData.length) {
      //   setResultFoundOnSearch(true);
      // }
      // else {
      //   setResultFoundOnSearch(false);
      // }
      let acc = accounts.map((data) => {
        if (value === data.accountNumber) {
          data.selected = true;
        }
        else {
          data.selected = false;
        }
        return data;
      });
      setAccounts(acc);
      setAllSelected(false);
      // setRequestLists(filteredData);
      getDocumentListFunc(1, value)
    }

    if (value === 'all') {
      let acc = accounts.map((data) => {
        data.selected = false;
        return data;
      });

      setAccounts(acc);
      setAllSelected(true);
      setRequestLists(requestListsFromApi);
      if (!requestListsFromApi.length) {
        setResultFoundOnSearch(true);
      }
      else {
        setResultFoundOnSearch(false);
      }
    }

  }

  //When to clear to all filter
  const clearAllFilter = () => {
    setRequestLists(requestListsFromApi);
    setFilterApplied(false);
    closeDrawer();
  }

  const handleSearchClick = (e) => {
    var lists = requestDocLists;
    e?.preventDefault();
    setResultFoundOnSearch(false)
    setFormStatus(false)
    setFilterValuesApply({ status: { 'In Progress': false, 'Completed': false, 'Clarification Needed': false, 'Submitted': false, 'Reopen': false }, customEnd: null, customStart: null, requestedDates: { startDate: '', endDate: '', requestedPeriod: '' }, categories: [] })
    setFilterApplied(false);
      if (accountsToFilter?.length == 1) {
        applyMultiLoanFilter('all', true);
      }
      if (searchInput === '') {
        setRequestLists(requestDocLists)
      } else {
        const updatedDocLists = lists.filter((item) => {
          return item.supportRequestNumber.toLowerCase().includes(searchInput?.toLowerCase())
        })
        setRequestLists(updatedDocLists)
        if (updatedDocLists == 0) {
          setResultFoundOnSearch(true)
        }
    }
  }

  const clearSearch = () => {
    setSearchInput('')
    setRequestLists(requestDocLists)
    setResultFoundOnSearch(false)
  }

  const isValidFile = (file) => {
    const allowedTypes = ['image/png', 'image/jpeg', 'application/pdf'];
    return allowedTypes.includes(file.type);
  };

  const handleCloseSnackBar = () => {
    scrollTop()
    setRequestPopup(false)
  }

  const handleFile = (event, replace) => {
    var allowedExtensions = /(\.png|\.jpg|\.pdf|\.jpeg)$/i;
    var specialCharacters =  /[\/:*?“<>|]/;
    var fileSize =  event.target.files[0].size / 1024 / 1024
    if (fileSize > 5) {
      setFilesName(event.target.files[0].name)
      setAlertStatus(true)
    } else if (!allowedExtensions.exec(event.target.value)) { 
      setFilesName(event.target.files[0].name)
      setAllowedExtensionsStatus(true)
    } else if (event.target.files[0].name.length > FILE_LENGTH_LIMIT) {
      setFilesName(event.target.files[0].name)
      setFileLengthStatus(true)
    }  else if (specialCharacters.test(event.target.files[0].name)) {
      setFilesName(event.target.files[0].name)
      setFileContainSpecialChar(true) 
    } else {
        const originalFile = event.target.files[0];
        let fileName = originalFile.name.toLowerCase();
        
        if (fileName.endsWith('.jpg.pdf') || fileName.endsWith('.jpeg.pdf') || fileName.endsWith('.png.pdf')) {
          const cleanedFileName = fileName.replace(/\.pdf$/i, ''); 
          const renamedFile = new File([originalFile], cleanedFileName, {
            type: originalFile.type,
          });
          onFileUpload(renamedFile, replace);
        } else {
          onFileUpload(originalFile, replace); 
        }
    }
  };

  const onFileUpload = async (file, replace) => {
    setFileUploadLoader(true)
    setErrorMessage('');
    const res = await uploadSupportDocuments(props.accountNumber, file, docs.length, replace, documentId, counter);
    if (res && res?.responseData?.lstResponseStatus && res?.responseData.lstResponseStatus[0]?.statusCode == '0') { 
      setFileUploadLoader(false)
      setCounter(counter + 1)
      if (replace) {
        let newObj = [...docs]  
        newObj[replaceIndex]['fileName'] = file.name
        newObj[replaceIndex]['documentId'] = res?.responseData?.responseData
        setReplaceStatus(false)
        setReplaceIndex()
        setDocumentIds()
        setDocs(newObj)
      } else {
        let newObj = [...docs]
        newObj.push({fileName: file.name, documentId: res.responseData.responseData})
        setDocs(newObj)
      }
    } else if (res && res?.responseData?.lstResponseStatus && res?.responseData.lstResponseStatus[0]?.statusCode !== "0") {
      setFileUploadLoader(false)
      setErrorMessage(res.lstResponseStatus[0].statusDesc)
      scrollTop()
    } else {
      setFileUploadLoader(false)
      setErrorMessage(renderDefaultMsg('400'));
      scrollTop()
   }
  };

  const deleteDoc = (id, index, name) => {
    setReplaceIndex(index)
    setDocumentIds(id)
    setDeletePopup(true)
    setFilesName(name)
  }

  const handleClose = () => {
    setDeletePopup(false)
  }

  const handleSubmit = () => {
    deleteDocuments(documentId)
  }

  const deleteDocuments = async (id) => {
    const response = await deleteSupportDocuments(props.accountNumber, id)
    if (response && response?.responseData?.lstResponseStatus && response?.responseData.lstResponseStatus[0]?.statusCode == 0) {  
      setDeletePopup(false)
      let newObj = [...docs]  
      newObj.splice(replaceIndex, 1)
      setDocs(newObj)
      setDocumentIds()
      setReplaceIndex()
    }  else if (response && response?.responseData?.lstResponseStatus && response?.responseData.lstResponseStatus[0]?.statusCode !== "0") {
      setErrorMessage(response.lstResponseStatus[0].statusDesc)
      scrollTop()
    } else {
      setErrorMessage(renderDefaultMsg('400'));
      scrollTop()
   }
  } 

  const downloadDocuments = async (docName, documentId) => {
    const response = await downloadSupportDocument(props.accountNumber, documentId)
    if (response) {
      const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', docName);
      document.body.appendChild(link);
      link.click();
      if (docName.includes('pdf')) {
        var a = document.createElement('a');
        a.target="_blank";
        a.href = url;
        a.click();
      }
    }
  } 

  const handleInputFile = (e) => {
    e.target.value = null;
  }

  const shortText = (text) => {
    if (text !== '') {
      return text.length < 25 ? text : text.substr(0, 25) + '...'
    } else {
      return text
    }
  }

  const handleDocumentRequest = () => {
    history.push('/DocumentRequest')
  }
  
  const handleAlertClose = () => {
    setAlertStatus(false)
  }
  
  const getToolTipMsg = () => {
    if (!btnDisabled) {
      return "Due to the status of your loan, “Create Ticket” button is disabled. Please contact us directly for any assistance."
    } else if (createTicket) {
      return "You have reached the limit for active support tickets. Please wait until your existing tickets are completed before creating a new one."
    } 
  }

  return (
    <CssBaseline>
      <Box container="true" maxWidth='xl' className={classes.root}>
        <Box className={classes.container}>
          <CustomBreadcrum backPage="Support" backPageLink="/HelpLanding" activePage="Support Tickets" />
          <h1 className={classes.pageHeading} color="textPrimary" component='h4'>Support Tickets</h1>
          <>
            <Box className={classes.infoStrip}>
              <p className={classes.errorMsg} dangerouslySetInnerHTML={{ __html: errMessage !== '' ? errMessage : '' }} />

              <Grid container spacing={1} justifyContent="space-around" columns={{ xs: 12, sm: 12, md: 12 }} >
                <Grid item xs={12} sm={3} md={3} className={classes.requestBtnBox}>
                 {!createTicket && btnDisabled && <Button className={classes.requestBtn} size="large" fullWidth onClick={() => openNewReqForm()}
                    variant="contained"
                    disabled={openForm}
                    color="primary">
                    CREATE TICKET
                  </Button> }

                  {(createTicket || !btnDisabled) && <Button className={classes.documentHeadDisable} size="large" fullWidth
                      variant='outlined'>
                      CREATE TICKET
                     
                      {!mediaQuery && <LightTooltip
                        title={getToolTipMsg()}
                        arrow  >
                        <span style={{ marginLeft: '3px', marginTop: '3px' }} ><ErrorOutlineIcon /></span>
                      </LightTooltip> }
                      {mediaQuery && 
                      <ClickAwayListener onClickAway={handleTooltipClose}>
                      <LightTooltip
                        title={getToolTipMsg()}
                          arrow
                          open={ openToolTip }
                        >
                          <span style={{ marginLeft: '3px', marginTop: '3px' }} onClick={handleTooltipOpen}><ErrorOutlineIcon /></span>
                        </LightTooltip>
                      </ClickAwayListener>}

                    </Button>}   
        
                </Grid>
      
                <Grid item xs={12} sm={9} md={9} className={classes.searchBox}>
                  <Grid container spacing={1} justifyContent="space-around" columns={{ xs: 12, sm: 12, md: 12 }} >

                    <Grid item xs={12} sm={12} md={12} className={classes.requestBtnBox}>

                      <form noValidate autoComplete="off" onSubmit={handleSearch}>
                        <TextField
                          placeholder={'Search Ticket by ID'}
                          variant="outlined"
                          InputLabelProps={{ shrink: false }}
                          className={classes.searchTextBox}
                          onChange={handleSearch}
                          onKeyDown={keyPress}
                          value={searchInput}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment>
                                {(searchInput !== "") &&
                                  <IconButton
                                    aria-label="clear search"
                                    onClick={() => clearSearch()}
                                    edge="end"
                                  >
                                    <ClearIcon />
                                  </IconButton>}
                                <IconButton className={classes.searchIcon} onClick={(e) => handleSearchClick(e)}>
                                  <SearchIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                            className: classes.searchField,
                          }}
                        />
                      </form>

                    </Grid>
                  </Grid>

                </Grid>
              </Grid>

              {openForm &&
                <Box className={classes.formContainer}>
                  <Box>

                    <Grid container>
                      <Grid item md={12} xs={12} lg={12}>
                        <Box>

                          <Grid container>
                            <Grid item md={11} xs={11} lg={11}>
                              <Box className={classes.requestNewDoc}>Create Ticket</Box>
                            </Grid>
                            <Grid item md={1} xs={1} lg={1}>
                              <IconButton className={classes.closeIcon} onClick={() => closeForm("Support Ticket - Clicked on Cross Ticket button", "SupportCross")}>
                                <CancelIcon />
                              </IconButton>
                            </Grid>
                          </Grid>

                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className={classes.requestContainer}>

                  {(accounts.length == 1) &&
                     <TextField
                        color="primary"
                        id="outlined-zip"
                        label="Loan"
                        variant="outlined"
                        type="text"
                        disabled
                        value={decrypt(accounts[0].accountNumber) + ' - ' + accounts[0].propertyAddress1}
                        fullWidth
                      />
                   }

                   {(accounts.length !== 1) && <> <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
                      <InputLabel id="borrower-type-select-outlined">Select Loan <span style={{ color: "red" }}>*</span></InputLabel>
                      <Select
                        labelId="borrower-type-outlined-label"
                        required
                        value={selectedLoan?.accountNumber}
                        label="Select Loan *"
                        className={classes.inputStyle}
                        fullWidth
                      >
                        {loansDetails}
                      </Select>
                    </FormControl>
                    </>}
                   
                    {(allDocumentTypes?.length > 0) &&
                      <Box style={{ paddingTop: '20px', width: '100%' }}>
                        <FormControl variant="outlined" className={classes.formControl} style={{ width: '100%' }}>
                          <InputLabel id="borrower-type-select-outlined">Select Category <span style={{ color: "red" }}>*</span></InputLabel>
                          <Select
                            labelId="borrower-type-outlined-label"
                            required
                            value={selectedItem.documentName}
                            label="Select Category *"
                            className={classes.inputStyle}
                            fullWidth
                          >
                            {allDocumentTypes}
                          </Select>
                        </FormControl>
                      </Box> 
                    }
                    
                      <Box className={classes.textareaSection}>
                        <label htmlFor="outlined_impacted250" style={{ fontWeight: 'bold', fontSize: '12px' }}>
                          Description <span style={{ color: 'red' }}>*</span>
                        </label>
                        <TextareaAutosize
                          style={{ height: '96px' }}
                          color="primary"
                          id={`outlined_impacted250`}
                          variant="outlined"
                          type="text"
                          name="comments"
                          maxLength="5000"
                          onChange={(event) => handleRequestDescChange(event)}
                          value={documentDesc}
                          InputLabelProps={{
                            FormLabelClasses: {
                              asterisk: classes.labelAsterisk
                            }
                          }}
                          className={`${classes.textArea}`}
                        >
                        </TextareaAutosize>
                        <Typography className={classes.textAreaValidation}>{calculateCommentLenth()}/5000</Typography>
                      </Box>
          
                       <Box className={classes.fileUpload}>
                          <Box className={classes.chooseFile}>
                            Attach a file (Optional):
                          </Box>
                          <Box>
                          <input
                                accept=".pdf, .png, .jpg, .jpeg"
                                type="file"
                                name='selectedFile'
                                style={{display: 'none'}}
                                id="upload-button"
                                onClick={(e) => handleInputFile(e)}
                                onChange={(e) => handleFile(e, true)}
                              /> 
                            {fileUploadLoader ? 
                                <Button component="label" type='submit' className={classes.fileButton} variant="contained" color='primary'>
                                  <CircularProgress color='primary' />
                                </Button>
                              :  
                            <Button component="label" variant="contained" className={((docs.length == 5) || (selectedItem.categoryCode == 'DR')) ? classes.disableFileBtn : classes.fileButton} disabled={((docs.length == 5) || (selectedItem.categoryCode == 'DR'))}>
                              <Box className={((docs.length == 5) || (selectedItem.categoryCode == 'DR')) ? classes.disableChooseBtn : classes.chooseFile}>CHOOSE FILE(S)</Box>
                              <VisuallyHiddenInput type="file"  accept=".pdf, .png, .jpg, .jpeg" onClick={(e) => handleInputFile(e)}
                              onChange={(e) => handleFile(e, false)} />
                            </Button> }
                          </Box>
                          <Box className={`${classes.chooseFile} info`} >
                            Max 5 files(PDF, JPG, PNG, JPEG) allowed of 5 MB each
                          </Box>
                        </Box>

                       <Grid container >
                         { docs?.length > 0 && docs.map((key, ind) => {  
                          return (
                           <Grid item xs={12} sm={12} md={6}>
                          
                             <Box className={classes.uploadedImageContainer}>
                               <Box className={classes.uploadedImage}>
                                  {key.fileName.includes('.pdf') ? <img className={classes.checkImg} src={pdfIcon} alt='image' /> :
                                   <img className={classes.checkImg} src={imageIcon} alt='image' /> }
                                   <Typography className={classes.imageText} onClick={() => downloadDocuments(key.fileName, key?.documentId)}>{shortText(key.fileName)} </Typography>
                                   <LightTooltip
                                     arrow  placement="top"
                                       title="Delete"
                                     >
                                      <DeleteIcon color="action" onClick={() => deleteDoc(key?.documentId, ind, key.fileName)} style={{cursor: 'pointer', color: '#4D4D4D', marginRight: 10}}></DeleteIcon>
                                   </LightTooltip>
                               </Box>
                             </Box>

                           </Grid>
                             )})}
                       </Grid> 
                      
                    <Box className={classes.warningBox}>
                      <InfoIcon style={{ height: '18px', color: '#007FFF' }} />
                      <Box className={classes.notification}>By submitting this request, you consent to receive updates related to this ticket via your registered email address and portal notifications.</Box>
                    </Box> 

                    <Grid container className={classes.footerSection}>
                      <Grid item md={12} xs={12} lg={12}>
                        <Grid container style={{ marginTop: '12px' }}>
                          <Grid item xs={5} md={6} className={classes.pr35}>
                            <Box className={classes.cancelBtnBox}>
                              <Button
                                className={classes.cancelBtn}
                                variant="outlined"
                                onClick={() => closeForm("Support Ticket - Clicked on Cancel Ticket button", "SupportCancel")}
                              >CANCEL</Button>
                            </Box>
                          </Grid>
                          <Grid item xs={7} md={6} className={classes.pl35}>
                            <Box className={classes.saveBtnBox}>
                              {loader ?
                                <Button disabled={true} type='submit' className={classes.saveBtn} variant="contained" color='primary'>
                                  <CircularProgress color='primary' />
                                </Button>
                                :
                                <Button
                                  className={classes.saveBtn}
                                  variant="contained"
                                  disabled={checkValidations()}
                                  onClick={() => submitRequestDocument()}
                                  color="primary">
                                  SUBMIT</Button>}
                            </Box>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>

                  </Box>
                </Box>
              }
            
              <Box>

                <Grid container spacing={1} justifyContent="space-around" style={{ padding: '12px 0px' }} columns={{ xs: 12, sm: 12, md: 12 }} >
                  <Grid item xs={8} sm={8} md={9}>
                    <h2 className={classes.documentRequest}>Support Tickets</h2>
                  </Grid>

                  <Grid item xs={4} sm={4} md={3} className={classes.filterSection}>

                    <Box className={classes.filterText} onClick={openFilters}>Filters <img src={Filter} className={classes.image} />
                      {filterApplied && <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" className={classes.filterApplied} viewBox="0 0 9 9" fill="none">
                        <circle cx="4.5" cy="4.5" r="4.5" fill="#E02020" />
                      </svg>}
                    </Box>
                  </Grid>
                </Grid>

                {(accountsToFilter?.length > 1) &&
                  <Box style={{ display: 'flex', marginBottom: '20px', marginTop: '12px' }}>
                    <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12 }}>
                      <Box className={`${classes.allLoanFilter} ${allSelected ? 'selected' : ''}`} onClick={() => applyAllFilter()}>All</Box>
                      {accountsToFilter.map((loan) => {
                        return (
                          <Box className={`${classes.loanNumber} ${loan.selected ? 'selected' : ''}`} onClick={() => applyMultiLoanFilter(loan.accountNumber)}>Loan {maskLoan(decrypt(loan.accountNumber))}</Box>
                        )
                      })}
                    </Grid>
                  </Box>
                }

                <Grid>
                  {openFilter && documentTypes && <FilterDrawer closeDrawer={closeDrawer} clearAllFilter={clearAllFilter} filterValuesApplied={filterValuesApply} applyFilter={applyFilter} categories={documentTypes}/>}
                </Grid>

                {(requestLists?.length > 0) &&
                  <Box className={classes.containerPadding}>
                    <Requests accountNumber={props.accountNumber} requestLists={requestLists} accounts={accounts} selectedLoan={selectedLoan} paginationData={paginationData} onNextClick={getDocumentListFunc}></Requests>
                  </Box>}
                {((requestLists?.length == 0) && !openForm && noResultFound) &&
                  <Box className={classes.noRecordFoundContainer}>
                    <img src={databaseIcon} />
                    <h2 className={classes.documentHead2}>No Records Found</h2>
                    <h2 className={classes.noRequestData}>No request data to show you right now.</h2>
                  </Box>
                }
                {noResultFoundOnSearch && !noResultFound &&
                  <Box className={classes.noRecordFoundContainer}>
                    <img src={databaseIcon} />
                    <h2 className={classes.documentHead2}>No Matching Results Found</h2>
                  </Box>
                }
              </Box>
                
                <FileSizeAlert
                  open={alertStatus}
                  handleAlertClose={handleAlertClose}
                  file={file}
                />

                <DeleteConfirmation
                  open={deleteStatus}
                  popupText={{statusTitle:'Deletion Request',statusBody:'Are you sure you really want to delete this document?'}}
                  handleCancelIcon={handleClose}
                  handleSubmitClose={handleClose}
                  handleSubmit={handleSubmit}
                />
              
                <RequestSubmitPopup
                  open={requestPopup}
                  submitResponse={submitResponse}
                  handleCancelIcon={handleCloseSnackBar}
                />

                <DocumentRequestPopup
                  open={documentRequestPopup}
                  handleCancelIcon={() => setDocumentRequestPopupStatus(false)}
                  handleDocumentRequest={handleDocumentRequest}
                />

                 <FileExtensionAlert
                    open={allowedExtensionsStatus}
                    handleExtensionAlertClose={handleExtensionAlertClose}
                    file={file}
                  />
              
            </Box>
          </>

        </Box>
      </Box>
     
    </CssBaseline>
  )
}
